<script setup>
import { computed } from "vue";
import dayjs from "dayjs";

const props = defineProps({
	date: String
})

const dateFormat = computed(() => {
	const date = dayjs(props.date)
	const day = date.date() >= 10 ? date.date() : `0${date.date()}`
	const month = date.month() + 1
	return {
		year: date.year(),
		month: month >= 10 ? month : `0${month}`,
		date: day
	}
})

</script>

<template>
	<div class="date-block">
		<div class="left">{{ dateFormat.date }}</div>
		
		<div class="split">
			/
		</div>
		
		<div class="right">
			<div class="year">{{ dateFormat.year }}</div>
			<div class="month">{{ dateFormat.month }}</div>
		</div>
	</div>
</template>

<style scoped lang="less">
.date-block {
	display: flex;
	align-items: center;
	color: #909399;
	
	.left, .split {
		font-size: 42px;
	}
	
	.split {
		margin: 0 6px;
	}
	
	.right {
		font-size: 18px;
		
		.year {
			margin-bottom: 3px;
		}
	}
}


@media only screen and (max-width: 1024px) {
	.date-block {
		
		.left, .split {
			font-size: 22px;
		}
		
		.split {
			margin: 0 6px;
		}
		
		.right {
			font-size: 14px;
			
			.year {
				margin-bottom: 3px;
			}
		}
	}
}
</style>